/*global Raven*/
/*global window*/
/*global history*/
/*creating the common modules*/
/*eslint angular/file-name: 0*/
// Raven.config('https://a04871dc7a684293819e0b2cd97ec9de@sentry.io/287021')
//     .addPlugin(Raven.Plugins.Angular)
//     .install();
angular.module('emarket.commons', []);
var modules = [
    'ui.router',
    'angular-cache',
    'ngMaterial',
    'ngCookies',
    'bc.TelephoneFilter',
    'md.data.table',
    'templates-app',
    'templates-common',
    'ngAnimate',
    'ngMessages',
    'ngFileUpload',
    'ngStorage',
    'restmod',
    'ui.scroll',
    '720kb.socialshare',
    'btford.socket-io',
    'ngSanitize',
    'emarket.commons',
    'emarket.auth',
    'emarket.main',
    'emarket.store',
    'emarket.search',
    'angulartics',
    'angulartics.google.analytics'
];
(function() {
    'use strict';
    angular
        .module('emarket', modules)
        .config(['$httpProvider', '$compileProvider', '$locationProvider', '$urlRouterProvider', '$mdInkRippleProvider', '$mdThemingProvider', '$provide', '$mdToastProvider', 'restmodProvider', 'PATH', 'EmarketConstant', function appConfig($httpProvider,
            $compileProvider,
            $locationProvider,
            $urlRouterProvider,
            $mdInkRippleProvider,
            $mdThemingProvider,
            $provide,
            $mdToastProvider,
            restmodProvider,
            PATH,
            EmarketConstant) {
            /* eslint angular/window-service:off*/
            // $compileProvider.debugInfoEnabled(false);
            // $httpProvider.useApplyAsync(true);
            $httpProvider.defaults.headers.delete = {
                'Content-Type': 'application/json;charset=utf-8'
            };

            //support html5 mode
            if (window.history && history.pushState) {
                $locationProvider.html5Mode(true);
            } else {
                //remove the !
                $locationProvider.hashPrefix('!');
            }
            $mdInkRippleProvider.disableInkRipple();
            restmodProvider.rebase({
                $config: {
                    style: 'MongooseStyle', // By setting the style variable the warning is disabled.
                    primaryKey: '_id',
                    urlPrefix: PATH.api
                    /* other style related configuration */
                }
            });
            $urlRouterProvider.otherwise('/');
            $mdThemingProvider.definePalette(EmarketConstant.theme.primary.name,
                EmarketConstant.theme.primary.values);
            $mdThemingProvider.definePalette(EmarketConstant.theme.accent.name,
                EmarketConstant.theme.accent.values);
            $mdThemingProvider
                .theme('default')
                .primaryPalette(EmarketConstant.theme.primary.name)
                .accentPalette(EmarketConstant.theme.accent.name, {
                    default: '500'
                });
            $mdThemingProvider
                .theme('dark-emarket')
                .primaryPalette(EmarketConstant.theme.primary.name)
                .accentPalette(EmarketConstant.theme.accent.name, {
                    default: '500'
                })
                .dark();
            $mdThemingProvider
                .theme('dark-navigation')
                .primaryPalette(EmarketConstant.theme.primary.name)
                .accentPalette('yellow')
                .dark();

            $mdToastProvider.addPreset('simpleMessage', {
                options: function() {
                    return {
                        template:
              '<md-toast>' +
              '  <div class="md-toast-content">' +
              '    {{ toast.text }}' +
              '  </div>' +
              '</md-toast>',
                        controller: function() {},
                        bindToController: true,
                        controllerAs: 'toast'
                    };
                }
            });
            $httpProvider.interceptors.push('AuthInterceptor');
            $httpProvider.interceptors.push('ErrorInterceptor');
            $provide.decorator('uiSrefDirective', ['$delegate', function($delegate) {
                return $delegate;
            }]);
        }])
        .controller('AppController', ['$state', '$rootScope', '$scope', '$mdMedia', '$window', '$log', '$mdToast', 'Announcer', 'StateQueue', 'ErrorHandler', 'Socket', 'THEME', function($state,
            $rootScope,
            $scope,
            $mdMedia,
            $window,
            $log,
            $mdToast,
            Announcer,
            StateQueue,
            ErrorHandler,
            Socket,
            THEME) {
            var announcer = Announcer.create($scope);
            var vm = this;
            vm.isLoaded = true;
            vm.themeColor = THEME.themeColor;
            var offlineToast = {
                template:
          '<md-toast class="md-top offline-toast">' +
          '  <div class="md-toast-content">' +
          '    <p><md-icon md-font-icon="zmdi zmdi-alert-triangle" class="md-warn"></md-icon>' +
          '     Pareces que no estas conectado a internet</p>' +
          '  </div>' +
          '</md-toast>',
                hideDelay: false
            };

            $window.addEventListener('online', function() {
                $window.document.querySelector('body').classList.remove('offline-mode');
                $mdToast.hide(offlineToast);
            });
            $window.addEventListener('offline', function() {
                $window.document.querySelector('body').classList.add('offline-mode');
                $mdToast.show(offlineToast);
            });
            announcer.on(Announcer.types.FULL_SCREEN_MODE, function(ev, mode) {
                vm.fullScreenMode = mode === false ? false : true;
            });
            announcer.on(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR, function(ev, mode) {
                vm.fullScreenModeNoToolbar = mode === false ? false : true;
            });
            announcer.on(Announcer.types.CHANGE_THEME_COLOR, function(ev, color) {
                vm.themeColor = color;
            });

            $rootScope.$on('$stateChangeSuccess', function(event,
                toState,
                toParams,
                fromState,
                fromParams) {
                if (toState.data && angular.isDefined(toState.data.pageTitle)) {
                    $rootScope.pageTitle = toState.data.pageTitle;
                } else {
                    $rootScope.pageTitle = 'eMarket';
                }

                //list of state to not transition back when go to login
                var noPushStates = [
                    'signup',
                    'main.signup-validation',
                    'forgot',
                    'forgot-validate',
                    'signinquestion'
                ];
                if (toState.name === 'auth' && noPushStates.indexOf(fromState.name) === -1) {
                    StateQueue.push(fromState);
                }
                if (toState.data && angular.isDefined(toState.data.showBackButton)) {
                    $rootScope.showBackButton = true;
                } else {
                    $rootScope.showBackButton = false;
                }
                $state.previous = { state: fromState, params: fromParams };
                vm.fullScreenMode = false;
                vm.fullScreenModeNoToolbar = false;
            });
            $rootScope.$on('$stateNotFound', function() {
                //not found
                $log.info('not found');
            });
            $rootScope.$on('$stateChangeError', function(event,
                toState,
                toParams,
                fromState,
                fromParams,
                error) {
                ErrorHandler.state(error, toState, toParams, fromState, fromParams);
            });

            // moment.locale('es-do', {
            //     relativeTime: {
            //         future: '%s',
            //         past: '%s',
            //         s: 'ahora',
            //         ss: '%ss',
            //         m: '1m',
            //         mm: '%dm',
            //         h: '1h',
            //         hh: '%dh',
            //         d: '1 día',
            //         dd: '%dd',
            //         M: '1 mes',
            //         MM: '%d meses',
            //         y: '1 año',
            //         yy: '%d años'
            //     }
            // });

            //TODO: put this on a services
            $scope.media = {
                xs: $mdMedia('xs'),
                gtxs: $mdMedia('gt-xs'),
                sm: $mdMedia('sm'),
                gtsm: $mdMedia('gt-sm'),
                md: $mdMedia('md'),
                gtmd: $mdMedia('gt-md'),
                lg: $mdMedia('lg'),
                gtlg: $mdMedia('gt-lg'),
                xl: $mdMedia('xl'),
                landscape: $mdMedia('landscape'),
                portrait: $mdMedia('portrait'),
                print: $mdMedia('print'),
                isMobile: $mdMedia('xs') || $mdMedia('sm')
            };

            $rootScope.$on('scroll:disable', function(e, disable) {
                if (disable) {
                    vm.disable = true;
                    vm.style = {
                        overflow: 'hidden'
                    };
                    vm.extraStyle = {};
                } else {
                    vm.disable = false;
                    vm.style = {
                        'touch-action': 'initial'
                    };
                    vm.extraStyle = {
                        'touch-action': 'initial'
                    };
                }
            });
        }]);
}());
